import { Box, Flex, Heading, Text, Icon } from '@chakra-ui/react';
import {
  MdLink as LinkIcon,
  MdImage as PhotoIcon,
  MdKeyboardVoice as DictateIcon,
  MdEditNote as ManualIcon,
} from 'react-icons/md';
import { useLocation } from 'wouter';
import { useImportSheet, type ImportSheetInitialView } from '@/contexts/ImportSheetContext';
import { ROUTES } from '@/types';

type Action =
  | { kind: 'sheet'; label: string; icon: React.ElementType; view: ImportSheetInitialView }
  | { kind: 'nav';   label: string; icon: React.ElementType; route: string };

const IMPORT_ACTIONS: Action[] = [
  { kind: 'sheet', label: 'Paste link',     icon: LinkIcon,       view: 'url'        },
  { kind: 'sheet', label: 'Photo',          icon: PhotoIcon,       view: 'image'      },
  { kind: 'sheet', label: 'Dictate',        icon: DictateIcon,     view: 'text'       },
  { kind: 'nav',   label: 'Manual edit',    icon: ManualIcon,      route: ROUTES.RECIPES_NEW() },
];


function ActionTile({ action, onClick, muted = false }: { action: Action; onClick: () => void; muted?: boolean }) {
  return (
    <Flex
      direction="column"
      align="center"
      gap={1.5}
      flex={{ base: 1, lg: 'none' }}
      cursor="pointer"
      onClick={onClick}
    >
      <Box
        w={{ base: '100%', lg: '62px' }}
        h="62px"
        borderRadius="15px"
        bg={muted ? 'bg.surface' : 'accent.secondarySubtle'}
        border="1px solid"
        borderColor={muted ? 'border.muted' : 'accent.secondaryBorder'}
        display="flex"
        alignItems="center"
        justifyContent="center"
        _hover={{ bg: muted ? 'bg.muted' : 'accent.secondaryBorder' }}
        transition="background 0.15s"
      >
        <Icon as={action.icon} boxSize={5} color={muted ? 'text.muted' : 'accent.secondary'} />
      </Box>
      <Text fontFamily="body" fontWeight="500" fontSize="10px" color="text.muted" whiteSpace="nowrap">
        {action.label}
      </Text>
    </Flex>
  );
}

export default function HomeImportRow() {
  const { open } = useImportSheet();
  const [, navigate] = useLocation();

  const handleClick = (action: Action) => {
    if (action.kind === 'sheet') open(action.view);
    else navigate(action.route);
  };

  return (
    <Box pb={4}>
      <Heading fontFamily="heading" fontWeight="800" fontSize="15px" color="text.primary" letterSpacing="-0.2px" px={4} pb={3}>
        Quick Add
      </Heading>
      <Flex gap={3} px={4} align="flex-start">
        {IMPORT_ACTIONS.map((action) => (
          <ActionTile key={action.label} action={action} onClick={() => handleClick(action)} />
        ))}
      </Flex>
    </Box>
  );
}
